import { useContext, useEffect, createContext, useState } from "react";
import { auth } from "../config/firebase";
import { signInWithPopup, signOut, onAuthStateChanged, GoogleAuthProvider } from "firebase/auth";

const AuthContext = createContext();

export const AuthContextProvider = ({ children }) => {
  const [user, setUser] = useState({});

  const googleSignIn = async () => {
    try {
      const provider = new GoogleAuthProvider();
      const result = await signInWithPopup(auth, provider);
      const user = result.user;

      // Check if the user's email has one of the allowed domains
      if (user.email && (user.email.endsWith("@satori-ai.com") || user.email.endsWith("@why-q.com"))) {
        // User has one of the allowed domains, proceed with the sign-in
        return user;
      } else {
        // User does not have the allowed domain, sign them out
        await logOut();
        throw new Error("Invalid email domain. Sign in with a @satori-ai.com or @why-q.com email.");
      }
    } catch (error) {
      throw error;
    }
  };

  const logOut = () => {
    signOut(auth);
  };

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      setUser(currentUser);
    });
    return () => {
      unsubscribe();
    };
  }, []);

  return <AuthContext.Provider value={{ googleSignIn, logOut, user }}>{children}</AuthContext.Provider>;
};

export const UserAuth = () => {
  return useContext(AuthContext);
};
